import { Helmet } from 'react-helmet-async';
import Cards from '../components/Cards';
import { useLanguage } from '../i18n/LanguageContext';

const Home = ({ garageData, loadFigure }) => {
  const { t } = useLanguage()


  return (
    <>
      <Helmet>
        <title>{t('metaHomeTitle')}</title>
        <meta
          name="description"
          content={t('metaHomeDesc')}
        />
      </Helmet>
      <section className="home_intro">
        <h2>{t('welcome')} <span>{t('welcomeHighlight')}</span></h2>
        <p>{t('homeIntro')}</p>
        <p className="home_intro_disclaimer">{t('homeDisclaimer')}</p>
      </section>
      <Cards cardsData={garageData} loadFigure={loadFigure} />
    </>
  )
}

export default Home;
